var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var OrgFeatureFlag_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { orgFeatureFlagSchema } from './jsonSchemas/orgFeatureFlag';
import { OrgFeatureFlagTypes } from './orgFeatureFlagTypes';
import { orgFeatureFlagSchemaValidation } from '../validations.generated';
// Use this to hide feature flags that are no longer in use.
// Currently deleting from OrgFeatureFlagTypes will break org when we fetch all FF if already set in DB.
export const ObsoleteOrgFeatureFlagTypes = [
    OrgFeatureFlagTypes.RequireChangeRequest,
    OrgFeatureFlagTypes.IncentivesRoles
];
export const toolHasFeatureFlag = (toolType) => {
    // get the first part of the feature flag name, which is the tool name which the feature flag is for
    const featureToolsList = Object.values(OrgFeatureFlagTypes).map((flagName) => flagName.split(/(?=[A-Z])/)[0]);
    return featureToolsList.includes(toolType);
};
let OrgFeatureFlag = OrgFeatureFlag_1 = class OrgFeatureFlag {
    constructor(flagName, flagValue, objectId, objectType) {
        this.flagName = flagName;
        this.flagValue = flagValue;
        this.objectId = objectId;
        this.objectType = objectType;
        JSON.validate(this, OrgFeatureFlag_1);
    }
};
OrgFeatureFlag = OrgFeatureFlag_1 = __decorate([
    JsonSchemaV2(orgFeatureFlagSchema, orgFeatureFlagSchemaValidation)
], OrgFeatureFlag);
export { OrgFeatureFlag };
//# sourceMappingURL=orgFeatureFlag.js.map